import { useState } from "react";
import Select from "react-select";
import { useGetWooCategoriesQuery } from "../features/api/wooApiSlice";

const WooProductFilters = ({ onFilterChange }) => {
  const { data: categories = [] } = useGetWooCategoriesQuery();
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [price, setPrice] = useState([0, 500]);
  const [search, setSearch] = useState("");

  const categoryOptions = categories.map((c) => ({
    value: c.id,
    label: c.name,
  }));

  const handleApplyFilters = () => {
    onFilterChange({
      category: selectedCategories.map((c) => c.value).join(","),
      min_price: price[0],
      max_price: price[1],
      search: search || undefined,
    });
  };

  return (
    <div className="woo-filters">
      <h4>Filter Products</h4>

      {/* Search Bar */}
      <label>Search</label>
      <input
        type="text"
        placeholder="Search products..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="woo-search-input"
      />

      {/* Category Multi-Select */}
      <label>Categories</label>
      <Select
        isMulti
        options={categoryOptions}
        value={selectedCategories}
        onChange={setSelectedCategories}
        className="woo-category-select"
      />

      {/* Price Range */}
      {/* <label>
        Price Range: ${price[0]} - ${price[1]}
      </label>
      <div className="price-slider">
        <input
          type="range"
          min="0"
          max="1000"
          value={price[0]}
          onChange={(e) => setPrice([+e.target.value, price[1]])}
        />
        <input
          type="range"
          min="0"
          max="1000"
          value={price[1]}
          onChange={(e) => setPrice([price[0], +e.target.value])}
        />
      </div> */}

      <button className="apply-btn" onClick={handleApplyFilters}>
        Apply Filters
      </button>
    </div>
  );
};

export default WooProductFilters;
